import React from 'react';
import TokenNameAndPan from 'components/account/card/TokenNameAndPan.js';
import { useTransitAccountIdContext } from 'context/TransitAccountIdContext.js';
import { ComponentLoading } from 'components/icons/LoadingIcon.js';
import { findPrimaryToken, isGhostCard } from 'components/manage-cards/TokenHelpers.js';
import { Error as ComponentError } from 'components/data/Error.js';
import { CardImage } from 'components/icons/CardBrands.js';

import * as layout from 'layouts/TakeOverLayout.module.css';
import { CARD_STATUS_SUSPENDED, getCardType } from 'utils/Cards.js';
import { useTransitAccount } from 'components/data/transit-account/TransitAccount.js';

/**
 * Get the ccard type icon and CardIconAndNickname / Last 4 for the currently
 * selected card
 */
const CardIconAndNickname = ({
	showCardIcon = true,
	showName = true,
}) => {
	const transit_account_id = useTransitAccountIdContext();
	const { data, loading, error } = useTransitAccount({ subsystemAccountReference: transit_account_id });

	if (loading) {
		return <ComponentLoading />;
	}

	if (error) {
		return <ComponentError error={error} />;
	}

	const ghostCard = isGhostCard(data.transitAccountQ);

	const primaryToken = findPrimaryToken(data.transitAccountQ.tokens);
	const primaryTokenInfo = primaryToken.tokenInfo;

	const cardType = ghostCard
		? null
		: getCardType({
			tokenInfo: primaryToken.tokenInfo,
			isMonochrome: primaryToken.frontendStatus === CARD_STATUS_SUSPENDED,
			mediaType: primaryToken.mediaType,
		});

	return (
		<div className={layout.cardDetails}>
			{showCardIcon &&
				<div className={layout.cardMedia}>
					<CardImage
						creditCardType={cardType}
						mobileWalletType={primaryTokenInfo.mobileWalletType}
						status={primaryToken.frontEndStatus}
					/>
				</div>
			}
			<div className={layout.cardName}>
				<TokenNameAndPan tokenInfo={primaryTokenInfo} mediaType={primaryToken.mediaType} showName={showName} elementType='span' />
			</div>
		</div>
	);
};

export default CardIconAndNickname;
